"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var OpportunityOption_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpportunityOption = exports.JobCreationType = exports.JobCreationSource = exports.BusinessTypeEnum = exports.ProductOrderConditionsEnum = exports.PrepaymentTypesEnum = void 0;
const class_validator_1 = require("class-validator");
const typeorm_1 = require("typeorm/browser");
const data_ui_1 = require("../data-ui");
const layouts_1 = require("../data-ui/layouts");
const opportunityOptionJobTargetValidator_1 = require("../validators/opportunityOptionJobTargetValidator");
const contact_profile_enum_1 = require("./contact-profile-enum");
const brand_3 = require("./brand");
const contact_1 = require("./contact");
const currency_tax_configuration_1 = require("./currency-tax-configuration");
const job_status_enum_1 = require("./job-status-enum");
const opportunity_1 = require("./opportunity");
const status_rules_names_enum_1 = require("./status-rules-names-enum");
const user_role_enum_1 = require("./user-role-enum");
const order_form_questions_1 = require("./order-form-questions");
var PrepaymentTypesEnum;
(function (PrepaymentTypesEnum) {
    PrepaymentTypesEnum["REQUIRED"] = "required";
    PrepaymentTypesEnum["OPTIONAL"] = "optional";
    PrepaymentTypesEnum["DISABLED"] = "disabled";
})(PrepaymentTypesEnum = exports.PrepaymentTypesEnum || (exports.PrepaymentTypesEnum = {}));
var ProductOrderConditionsEnum;
(function (ProductOrderConditionsEnum) {
    ProductOrderConditionsEnum["REQUIRE_INVOICE_EID"] = "Require Invoice EID";
    ProductOrderConditionsEnum["REQUIRE_EID"] = "Require EID";
})(ProductOrderConditionsEnum = exports.ProductOrderConditionsEnum || (exports.ProductOrderConditionsEnum = {}));
var BusinessTypeEnum;
(function (BusinessTypeEnum) {
    BusinessTypeEnum["B2B"] = "B2B";
    BusinessTypeEnum["B2C"] = "B2C";
    BusinessTypeEnum["B2B2C"] = "B2B2C";
})(BusinessTypeEnum = exports.BusinessTypeEnum || (exports.BusinessTypeEnum = {}));
var JobCreationSource;
(function (JobCreationSource) {
    JobCreationSource["Admin"] = "admin";
    JobCreationSource["Brand"] = "brand";
    JobCreationSource["Partner"] = "partner";
    JobCreationSource["Order_intake"] = "order_intake";
})(JobCreationSource = exports.JobCreationSource || (exports.JobCreationSource = {}));
var JobCreationType;
(function (JobCreationType) {
    JobCreationType["PRECHECK"] = "precheck";
    JobCreationType["INSTALLATION"] = "installation";
    JobCreationType["HARDWARE_SALE"] = "hardware_sale";
})(JobCreationType = exports.JobCreationType || (exports.JobCreationType = {}));
let OpportunityOption = OpportunityOption_1 = class OpportunityOption {
};
OpportunityOption.jobTypeAndCreationSourceOptions = (() => {
    const options = [];
    const jobStatusWithoutNew = Object.values(job_status_enum_1.JobStatusEnum).filter((value) => value !== job_status_enum_1.JobStatusEnum.NEW);
    for (const jobType of Object.values(JobCreationType)) {
        for (const creationSource of Object.values(JobCreationSource)) {
            for (const jobState of Object.values(jobStatusWithoutNew)) {
                options.push(`${jobType}/${creationSource}=${jobState}`);
            }
        }
    }
    return options;
})();
__decorate([
    data_ui_1.DataUi.SearchField(),
    data_ui_1.DataUi.Override({ generated: true }),
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.PrimaryGeneratedColumn)({
        type: 'bigint',
        name: 'id',
    }),
    __metadata("design:type", Number)
], OpportunityOption.prototype, "id", void 0);
__decorate([
    data_ui_1.DataUi.SearchField(),
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.OneToOne)(() => opportunity_1.Opportunity, (o) => o.opportunityOptions, {
        nullable: false,
    }),
    (0, typeorm_1.JoinColumn)({ name: 'opportunity_sfid' }),
    __metadata("design:type", opportunity_1.Opportunity)
], OpportunityOption.prototype, "opportunity", void 0);
__decorate([
    data_ui_1.DataUi.SearchField(),
    data_ui_1.DataUi.Override({ label: 'Account for Communication' }),
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.Index)(),
    (0, typeorm_1.ManyToOne)(() => brand_3.Brand, (brand) => brand.id, { nullable: true }),
    (0, typeorm_1.JoinColumn)({ name: 'injected_communication_account_sfid' }),
    __metadata("design:type", brand_3.Brand)
], OpportunityOption.prototype, "brand", void 0);
__decorate([
    data_ui_1.DataUi.SearchField(),
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.Index)(),
    (0, typeorm_1.ManyToOne)(() => brand_3.Brand, (brand) => brand.id, { nullable: true }),
    (0, typeorm_1.JoinColumn)({ name: 'brand_1' }),
    __metadata("design:type", brand_3.Brand)
], OpportunityOption.prototype, "brand_1", void 0);
__decorate([
    data_ui_1.DataUi.SearchField(),
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.Index)(),
    (0, typeorm_1.ManyToOne)(() => brand_3.Brand, (brand) => brand.id, { nullable: true }),
    (0, typeorm_1.JoinColumn)({ name: 'brand_2' }),
    __metadata("design:type", brand_3.Brand)
], OpportunityOption.prototype, "brand_2", void 0);
__decorate([
    data_ui_1.DataUi.Description('Set for all newly issued accounting documents for that opporunity'),
    data_ui_1.DataUi.SearchField(),
    data_ui_1.DataUi.Override({ label: 'Purchase Order Number' }),
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.Column)('character varying', {
        nullable: true,
        length: 255,
        name: 'purchase_order_number',
    }),
    __metadata("design:type", String)
], OpportunityOption.prototype, "purchaseOrderNumber", void 0);
__decorate([
    data_ui_1.DataUi.Description('Set for all newly issued accounting documents for that opporunity'),
    data_ui_1.DataUi.Override({ label: 'Due Days' }),
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.Column)('int', {
        default: 14,
        name: 'due_days',
    }),
    __metadata("design:type", Number)
], OpportunityOption.prototype, "dueDays", void 0);
__decorate([
    data_ui_1.DataUi.Description('Which user types can create job proposals'),
    data_ui_1.DataUi.Override({ label: 'Can Create Proposals' }),
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.Column)({
        type: 'enum',
        enum: user_role_enum_1.UserRoleEnum,
        array: true,
        default: '{}',
    }),
    __metadata("design:type", Array)
], OpportunityOption.prototype, "canCreateProposal", void 0);
__decorate([
    data_ui_1.DataUi.Description('Which user types can approve job proposals'),
    data_ui_1.DataUi.Override({ label: 'Can Approve Proposals' }),
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.Column)({
        type: 'enum',
        enum: user_role_enum_1.UserRoleEnum,
        array: true,
        nullable: true,
        default: '{}',
    }),
    __metadata("design:type", Array)
], OpportunityOption.prototype, "canApproveProposal", void 0);
__decorate([
    data_ui_1.DataUi.Description('Which user types can pre-approve job proposals'),
    data_ui_1.DataUi.Override({ label: 'Can Pre Approve Proposals' }),
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.Column)({
        type: 'enum',
        enum: user_role_enum_1.UserRoleEnum,
        array: true,
        default: '{}',
    }),
    __metadata("design:type", Array)
], OpportunityOption.prototype, "canPreApproveProposal", void 0);
__decorate([
    data_ui_1.DataUi.Description('Additionally to the <strong>Can Approve Proposals</strong>, specify which contact profiles of the selected user types can approve proposals'),
    (0, typeorm_1.Column)({
        type: 'enum',
        enum: contact_profile_enum_1.ContactProfileEnum,
        array: true,
        name: 'approval_contact_profiles',
        default: '{}',
    }),
    __metadata("design:type", Array)
], OpportunityOption.prototype, "approvalContactProfiles", void 0);
__decorate([
    data_ui_1.DataUi.Description('Sets the From: field in emails sent to customers'),
    data_ui_1.DataUi.Override({ label: 'Sender (Customer)' }),
    (0, typeorm_1.Column)('character varying', {
        nullable: true,
    }),
    __metadata("design:type", String)
], OpportunityOption.prototype, "senderForCustomer", void 0);
__decorate([
    data_ui_1.DataUi.Description('The status a job goes to when customer approves a quote'),
    data_ui_1.DataUi.Override({ label: 'Target Status for Customer Approval' }),
    data_ui_1.DataUi.EnumValues(job_status_enum_1.JobStatusEnum),
    (0, typeorm_1.Column)({
        type: 'enum',
        enum: job_status_enum_1.JobStatusEnum,
        nullable: true,
    }),
    __metadata("design:type", String)
], OpportunityOption.prototype, "customerApprovalTargetStatus", void 0);
__decorate([
    data_ui_1.DataUi.Description('Defines if a job needs to be prepaid 100% before execution. Note that there is a separate automatic 30% prepayment logic not related to this setting'),
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    data_ui_1.DataUi.EnumValues(PrepaymentTypesEnum),
    (0, typeorm_1.Column)({
        type: 'enum',
        enum: PrepaymentTypesEnum,
        default: PrepaymentTypesEnum.DISABLED,
    }),
    __metadata("design:type", String)
], OpportunityOption.prototype, "prepayment", void 0);
__decorate([
    data_ui_1.DataUi.Description('Tax rates for all jobs for that opportunity'),
    data_ui_1.DataUi.Override({ label: 'Currency & Tax' }),
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.Index)(),
    (0, typeorm_1.ManyToOne)(() => currency_tax_configuration_1.CurrencyTaxConfiguration, (currencyTax) => currencyTax.opportunities),
    __metadata("design:type", currency_tax_configuration_1.CurrencyTaxConfiguration)
], OpportunityOption.prototype, "currencyTaxConfig", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.HIDE_IN_FORM),
    (0, typeorm_1.Column)('jsonb', {
        nullable: true,
        name: 'customer_price_comments',
    }),
    __metadata("design:type", Object)
], OpportunityOption.prototype, "customerPriceComments", void 0);
__decorate([
    data_ui_1.DataUi.Description('When a value is set, triggers displaying additional information in the customer app'),
    data_ui_1.DataUi.Override({ label: 'Customer Subsidy' }),
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.Column)('float', {
        nullable: true,
        name: 'customer_subsidy',
    }),
    __metadata("design:type", Number)
], OpportunityOption.prototype, "customerSubsidy", void 0);
__decorate([
    data_ui_1.DataUi.Description(`Used to calculate <strong>Job - date expected</strong> property`),
    data_ui_1.DataUi.Override({ label: 'Delivery Date On Job Creation' }),
    (0, typeorm_1.Column)('boolean', {
        name: 'delivery_date_on_job_creation',
        nullable: false,
        default: true,
    }),
    __metadata("design:type", Boolean)
], OpportunityOption.prototype, "deliveryDateOnJobCreation", void 0);
__decorate([
    data_ui_1.DataUi.Description(`What is required to create product orders`),
    data_ui_1.DataUi.Override({ label: 'Product Order Condition' }),
    data_ui_1.DataUi.EnumValues(ProductOrderConditionsEnum),
    (0, typeorm_1.Column)({
        nullable: true,
    }),
    __metadata("design:type", String)
], OpportunityOption.prototype, "productOrderCondition", void 0);
__decorate([
    data_ui_1.DataUi.Override({ label: 'Brand Can View Quote (Customer)' }),
    (0, typeorm_1.Column)('boolean', {
        name: 'brand_can_view_quote',
        nullable: false,
        default: false,
    }),
    __metadata("design:type", Boolean)
], OpportunityOption.prototype, "brandCanViewQuote", void 0);
__decorate([
    data_ui_1.DataUi.Override({ label: 'Brand Can View Quote (Brand)' }),
    (0, typeorm_1.Column)('boolean', {
        name: 'brand_can_view_brand_quote',
        nullable: false,
        default: false,
    }),
    __metadata("design:type", Boolean)
], OpportunityOption.prototype, "brandCanViewBrandQuote", void 0);
__decorate([
    data_ui_1.DataUi.Description(`Lists all applied status automations and options related to a job status lifecycle`),
    data_ui_1.DataUi.LayoutConfig(layouts_1.HIDE_IN_TABLE),
    data_ui_1.DataUi.Override({ label: 'Status Rules' }),
    (0, typeorm_1.Column)({
        type: 'enum',
        enum: status_rules_names_enum_1.StatusRulesNamesEnum,
        array: true,
        default: '{}',
    }),
    __metadata("design:type", Array)
], OpportunityOption.prototype, "statusRules", void 0);
__decorate([
    data_ui_1.DataUi.Description(`Show brand specific information in pdf protocols`),
    data_ui_1.DataUi.Override({ label: 'Brand Info On Protocols' }),
    (0, typeorm_1.Column)('boolean', {
        name: 'brand_info_on_protocols',
        nullable: false,
        default: false,
    }),
    __metadata("design:type", Boolean)
], OpportunityOption.prototype, "brandInfoOnProtocols", void 0);
__decorate([
    data_ui_1.DataUi.EnumValues(BusinessTypeEnum),
    (0, typeorm_1.Column)({
        type: 'enum',
        enum: BusinessTypeEnum,
        default: BusinessTypeEnum.B2B2C,
    }),
    __metadata("design:type", String)
], OpportunityOption.prototype, "businessType", void 0);
__decorate([
    data_ui_1.DataUi.Override({ label: 'Custom Services Margin List Price (%)' }),
    data_ui_1.DataUi.Description(`Used to define the price list when a partner creates custom services. Defaults to 10.`),
    (0, typeorm_1.Column)('decimal', {
        nullable: true,
    }),
    __metadata("design:type", Number)
], OpportunityOption.prototype, "customServicesMargin", void 0);
__decorate([
    data_ui_1.DataUi.Override({ label: 'Custom Services Margin Selling Price (%)' }),
    data_ui_1.DataUi.Description(`Used to define the selling list when a partner creates custom services. Defaults to 10.`),
    (0, typeorm_1.Column)('decimal', {
        nullable: true,
    }),
    __metadata("design:type", Number)
], OpportunityOption.prototype, "customServicesMarginSelling", void 0);
__decorate([
    data_ui_1.DataUi.SearchField({
        filter: [
            {
                field: 'account.id',
                operator: 'in',
                value: (obj) => [obj.brand.id, obj.opportunity.brand.id],
            },
        ],
    }),
    data_ui_1.DataUi.Override({ label: 'Brand Contact for Brand Quote Email' }),
    data_ui_1.DataUi.Description(`Not used`),
    (0, typeorm_1.OneToMany)(() => contact_1.Contact, (brand_contacts) => brand_contacts.opportunityOption),
    __metadata("design:type", Array)
], OpportunityOption.prototype, "brandContacts", void 0);
__decorate([
    data_ui_1.DataUi.Description(`Configures in which status does a newly created job go to.` +
        `For example <strong>precheck/order_intake=open</strong> means ` +
        `that precheck jobs created via the order intake end up with status open`),
    data_ui_1.DataUi.EnumValues(OpportunityOption_1.jobTypeAndCreationSourceOptions),
    (0, typeorm_1.Column)({
        type: 'text',
        array: true,
        nullable: true,
        default: () => "'{}'",
    }),
    (0, class_validator_1.Validate)(opportunityOptionJobTargetValidator_1.JobTargetSourceValidator, {
        message: 'Duplicated target statuses are not allowed',
    }),
    __metadata("design:type", Array)
], OpportunityOption.prototype, "jobTargetStatusSource", void 0);
__decorate([
    data_ui_1.DataUi.Description(`Defines a form to be submitted in case of multiday Opportunity. It is used for partner diary functionality`),
    (0, typeorm_1.ManyToOne)(() => order_form_questions_1.Form),
    __metadata("design:type", order_form_questions_1.Form)
], OpportunityOption.prototype, "multidayDocumentationForm", void 0);
OpportunityOption = OpportunityOption_1 = __decorate([
    data_ui_1.DataUi.Permissions({
        read: [
            contact_profile_enum_1.ContactProfileEnum.CUSTOMER_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.PARTNER_ONBOARDING,
            contact_profile_enum_1.ContactProfileEnum.BRAND_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.GID,
            contact_profile_enum_1.ContactProfileEnum.PARTNER_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.FINANCE,
            contact_profile_enum_1.ContactProfileEnum.FINANCE_POWER_USER,
            contact_profile_enum_1.ContactProfileEnum.PRODUCT,
            contact_profile_enum_1.ContactProfileEnum.PRODUCT_POWER_USER,
        ],
        write: [contact_profile_enum_1.ContactProfileEnum.PRODUCT, contact_profile_enum_1.ContactProfileEnum.PRODUCT_POWER_USER],
    }),
    data_ui_1.DataUi.Name({
        name: 'OpportunityOption',
        nameProperties: ['opportunity.name'],
    }),
    data_ui_1.DataUi.Description('Additional options for opportunities'),
    data_ui_1.DataUi.DefaultLayoutConfig(layouts_1.HIDE_IN_TABLE),
    (0, typeorm_1.Entity)('opportunity_options', { schema: 'public' })
], OpportunityOption);
exports.OpportunityOption = OpportunityOption;
//# sourceMappingURL=opportunity-option.js.map